import { render } from "./PsihiatriePage.vue?vue&type=template&id=11c2002f"
import script from "./PsihiatriePage.vue?vue&type=script&lang=js"
export * from "./PsihiatriePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__